export default __webpack_public_path__ + "static/media/NB-IOT-OPEN.f246407a.png";